import type { ColumnDef, LevelDef, PickupDef, SegmentDef } from '../types';

// OP-000, the test level of milestone M1 (GDD §16.4): a short level written by hand with the format of
// §15.6, with columns, dollar bundles and one checkpoint. It is not part of the campaign and is never saved.

const column = (x: number, gapY: number): ColumnDef => ({ x, gapY, gapH: 4.0, skin: 'test' });
const dollar = (x: number, y: number): PickupDef => ({ x, y, type: 'dollar' });

const takeoff: SegmentDef = { id: 'test-takeoff', kind: 'takeoff', length: 40, columns: [], enemies: [], pickups: [] };

const pattern01: SegmentDef = {
  id: 'test-pattern-01',
  kind: 'pattern',
  length: 50,
  columns: [column(10, 6.0), column(19, 7.5), column(28, 5.0), column(37, 7.0), column(46, 6.0)],
  enemies: [],
  pickups: [dollar(13.5, 6.4), dollar(14.5, 6.8), dollar(15.5, 7.2)],
};

const pattern02: SegmentDef = {
  id: 'test-pattern-02',
  kind: 'pattern',
  length: 30,
  columns: [column(5, 6.5), column(14, 4.5), column(23, 6.0)],
  enemies: [],
  pickups: [dollar(8.5, 6.0), dollar(9.5, 5.5), dollar(10.5, 5.0)],
};

const airstrip: SegmentDef = { id: 'test-airstrip', kind: 'airstrip', length: 60, columns: [], enemies: [], pickups: [] };

export const OP_000_SEGMENTS: readonly SegmentDef[] = [takeoff, pattern01, pattern02, airstrip];

/** World 1 tuning, level 1 (GDD §5.4); the finish line is at x = 180 and the checkpoint at half. */
export const OP_000: LevelDef = {
  id: '0-0',
  op: 'OP-000',
  name: 'Banco de pruebas',
  world: 1,
  scrollSpeed: 5.0,
  segments: OP_000_SEGMENTS.map((segment) => segment.id),
  checkpoints: [{ id: 'CP-000-A', x: 90 }],
  ending: 'airstrip',
  test: true,
};
